import type { IconComponentProps } from "..";

export function OculusIcon(props: IconComponentProps) {
	return (
		<svg
			{...props}
			fill="currentColor"
			role="img"
			viewBox="611.6 464.98 248.4 150.05"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Oculus</title>
			<path d="m832.2 482c-8.7-7-18.8-11.9-29.7-14.5-6.2-1.5-12.5-2.2-18.9-2.4-4.7-0.2-9.5-0.1-14.2-0.1h-67.3c-4.7 0-9.5 0-14.2 0.1-6.4 0.2-12.6 0.9-18.9 2.4-10.9 2.6-20.9 7.5-29.6 14.5-17.6 14.1-27.8 35.4-27.8 58s10.2 43.9 27.8 58c8.7 7 18.8 11.9 29.7 14.5 6.2 1.5 12.5 2.2 18.9 2.4 4.7 0.2 9.5 0.1 14.2 0.1h67.3c4.7 0 9.5 0 14.2-0.1 6.4-0.2 12.6-0.9 18.9-2.4 10.9-2.6 20.9-7.5 29.6-14.5 17.6-14.1 27.8-35.4 27.8-58s-10.2-43.9-27.8-58zm-32.9 78.2c-3.3 2.3-7 3.7-10.9 4.3s-7.9 0.5-11.8 0.5h-81.5c-4 0-7.9 0.1-11.8-0.5-4-0.6-7.6-2-10.9-4.3-6.6-4.6-10.6-12.1-10.6-20.2s4-15.6 10.6-20.2c3.3-2.3 7-3.7 10.9-4.3s7.9-0.5 11.8-0.5h81.5c4 0 7.9-0.1 11.8 0.5 4 0.6 7.6 2 10.9 4.3 6.6 4.6 10.6 12.1 10.6 20.2 0.1 8.1-3.9 15.6-10.6 20.2z" />
		</svg>
	);
}
